import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import cachios from 'cachios'
import VideoComponent from './video';
import { List } from 'react-content-loader'
import Slider from "react-slick";

class HomeEvents extends Component {
    constructor(props) {
        super(props);
        this.state = {
            langeng: localStorage.getItem('lang') ? false : true
        }
    }

    checkopen(data) {
        this.setState({
            isVideoModalOpen: data
        })
    }

    componentWillMount() {
        //EVENTS
        cachios.get(BASE + 'api/events?from=0&size=4', {
            ttl: 300 /* seconds */,
        })
            .then((data) => {
                console.log(data,'date')

                let date = [], i,earray=[]
                for (i = 0; i < data.data.hits.hits.length; i++) {
                    var utcSeconds = data.data.hits.hits[i]._source.field_date;
                    var d = new Date(0); // The 0 there is the key, which sets the date to the epoch
                    d.setUTCSeconds(utcSeconds);
                    earray.push(JSON.parse(data.data.hits.hits[i]._source.nid[0]))
                    console.log(data.data.hits.hits[i]._source.field_date,d,'url')
                    date.push(d)
                }
                localStorage.setItem('earray', JSON.stringify(earray))
                this.setState({
                    event: data.data.hits.hits,
                    date: date
                })
            })
            .catch((err) => {
                console.log('not found')
            })
    }

    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false
        };

        return (
            <div className="newhomebook newpad0">
                <div className="newhomebookdiv">
                    <div style={{ marginBottom: 0 }} className="row">
                        <div className="neweventsec col s12 m6 l6">
                            <div className="newhometitle">
                                <Link to="/events/upcoming">{this.props.isArabic == true ? 'أحداث' : 'Events'}</Link>
                            </div>
                            <Slider {...settings} >
                                {this.state.event && this.state.date ?
                                    this.state.event.map((event, index) => {
                                        return (
                                            <div className="views-field views-field-nothing homeevents">
                                                <span className="field-content">

                                                    <div className="" style={{ borderBottom: 'none' }}>
                                                        <div className="newhomesubhead">
                                                            <Link to={{ pathname: '/event_desc/' + `${event._source.nid[0]}` }}>
                                                                {event._source.title[0].length < 60 ? event._source.title[0] : event._source.title[0].substring(0, 60) + '...'}
                                                            </Link>
                                                        </div>
                                                        <div className="datevenue">
                                                            <div className="date">
                                                                <span className="date-display-range">
                                                                    <span className="date-display-start" >
                                                                        {this.state.date[index].getDate() + '-' +Number(this.state.date[index].getMonth()+1) + '-' + this.state.date[index].getFullYear()}
                                                                    </span>
                                                                    <span className="date-display-start" >
                                                                        {new Date(this.state.date[index]).toLocaleTimeString().replace(/([\d]+:[\d]{2})(:[\d]{2})(.*)/, "$1$3")}
                                                                        {/* {`${this.state.date[index].getHours() < 10 ? "0" + this.state.date[index].getHours() : this.state.date[index].getHours()}` + ':' + `${this.state.date[index].getMinutes() < 10 ? "0" + this.state.date[index].getMinutes() : this.state.date[index].getMinutes()}`} */}
                                                                    </span>
                                                                </span>
                                                            </div>
                                                            <div className="venue">
                                                                {event._source.field_venue ? event._source.field_venue[0] : ''}
                                                            </div>
                                                        </div>
                                                        {event._source.body ?
                                                            event._source.body[0].length > 180 ?
                                                                <div className="eventbody">
                                                                    {event._source.body[0].substring(0, 230) + '...'}
                                                                    <Link to={{ pathname: '/event_desc/' + `${event._source.nid[0]}` }}>
                                                                        More
                                                             </Link>
                                                                </div>
                                                                :
                                                                <div className="eventbody">
                                                                    {event._source.body[0]}
                                                                </div>
                                                            : ''}
                                                    </div>

                                                </span>
                                            </div>
                                        )
                                    }
                                    )
                                    : <List />}
                            </Slider>
                        </div>
                        <div id="newvideosec" className="col s12 m6 l6">
                            <VideoComponent checkopen={(data) => this.checkopen(data)} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default HomeEvents;